import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/store/auth';
import type { Profile } from '@/api/types/common';

interface Props {
  children: React.ReactNode;
  /** Roles permitted to view this subtree. Defaults to admin-only. A profile
   *  whose role is not in this list is sent to /unsupported-role. */
  roles?: Array<Profile['role']>;
}

export function ProtectedRoute({ children, roles = ['admin'] }: Props) {
  const { token, user, profile } = useAuth();
  const location = useLocation();

  // Logged in = either a Bearer token (legacy/mobile) OR a user object set by
  // a successful cookie-auth login. The session cookie itself isn't visible
  // to JS, so we use the persisted user object as the proxy. If the cookie
  // has actually expired, the next API call will 401 and the axios
  // interceptor will redirect here anyway.
  if (!token && !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (profile && !roles.includes(profile.role)) {
    return <Navigate to="/unsupported-role" replace />;
  }
  return <>{children}</>;
}
